import SchedulerFactory from "./scheduler_factory";
import allExtensions from "./ext/extensions_all";

const factory = new SchedulerFactory(allExtensions);

const scheduler = factory.getSchedulerInstance();
const Scheduler = factory;

if(typeof window !== "undefined"){
	window.scheduler = scheduler;
	window.Scheduler = Scheduler;

	if (!window.$dhx) {
		window.$dhx = {};
	}

	window.$dhx.scheduler = scheduler;
	window.$dhx.Scheduler = Scheduler;

}

export { scheduler, Scheduler };
export {
	ar,
	be,
	ca,
	cn,
	cs,
	da,
	de,
	el,
	en,
	es,
	fi,
	fr,
	he,
	hu,
	id,
	it,
	jp,
	nb,
	nl,
	no,
	pl,
	pt,
	ro,
	ru,
	si,
	sk,
	sv,
	tr,
	ua
} from "./locale/locales";